import { Link } from "react-router-dom";
import Reveal from "@/components/Reveal";

export default function Hero() {
  const heroImg =
    "https://static.prod-images.emergentagent.com/jobs/c1a075fa-8b15-42e2-9c19-a7a7f32ee730/images/2c781c1482cb265c3d869041a329a40cde311e0caec6ca3246378272de561ab8.png";

  return (
    <section className="relative overflow-hidden bg-ink-0" data-testid="hero-section">
      {/* Layered depth: faint grid + rust radial glow */}
      <div className="absolute inset-0 grid-faint opacity-60 pointer-events-none" aria-hidden="true" />
      <div className="absolute inset-0 glow-rust opacity-90 pointer-events-none" aria-hidden="true" />
      <div className="absolute inset-x-0 bottom-0 h-px bg-white/[0.08]" />

      <div className="container-edge pt-16 md:pt-24 lg:pt-32 pb-24 lg:pb-36 relative z-10">
        <div className="grid grid-cols-12 gap-x-8 gap-y-12">
          <Reveal className="col-span-12 lg:col-span-7">
            <div className="eyebrow mb-7" data-testid="hero-eyebrow">
              Patient Voice → Evidence → Strategy
            </div>
            <h1
              className="font-serif font-normal text-[2.6rem] sm:text-5xl lg:text-[5.2rem] leading-[1.04] tracking-[-0.025em] text-parchment-bright"
              data-testid="hero-headline"
            >
              Patient voice,
              <span className="block italic text-parchment-bright"> translated into evidence.</span>
            </h1>
            <p
              className="mt-8 text-lg md:text-xl text-parchment/85 leading-relaxed max-w-2xl"
              data-testid="hero-subheadline"
            >
              Voice2Evidence helps{" "}
              <span className="text-parchment-bright font-medium">Medical Affairs, Market Access, HEOR, Patient Engagement, and Brand teams</span>{" "}
              transform real-world patient voice into decision-ready evidence across the asset lifecycle.
            </p>
            <p className="mt-5 text-[15.5px] text-parchment/75 leading-relaxed max-w-2xl" data-testid="hero-tagline">
              It is especially valuable for late-stage, launch, and post-launch brands where patient experience can directly shape evidence, access, medical, and engagement strategy.
            </p>
            <div className="flex flex-wrap items-center gap-4 mt-10">
              <Link to="/contact" className="btn-accent" data-testid="hero-cta-briefing">
                Request a Briefing
              </Link>
              <Link to="/framework" className="btn-secondary" data-testid="hero-cta-framework">
                Explore the Framework
              </Link>
            </div>
          </Reveal>

          <Reveal className="col-span-12 lg:col-span-5 lg:pl-6" delay={120}>
            <div className="relative card-dark p-0 overflow-hidden">
              <div className="aspect-[4/5] relative overflow-hidden">
                <img
                  src={heroImg}
                  alt="Abstract waveform morphing into evidence nodes"
                  className="w-full h-full object-cover"
                  style={{ filter: "invert(1) hue-rotate(180deg) saturate(0.85) brightness(0.95)" }}
                  data-testid="hero-image"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-ink-2 via-transparent to-transparent" />
                <div className="absolute inset-0 bg-gradient-to-br from-rust/10 via-transparent to-transparent" />
              </div>
              <div className="px-6 py-5 border-t border-white/[0.08] flex items-center justify-between">
                <div>
                  <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-muted-on-dark">Signal · 001</div>
                  <div className="font-serif text-xl text-parchment mt-1">Voice → Evidence</div>
                </div>
                <div className="flex items-center gap-2">
                  <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-muted-on-dark">Engagement in flight</span>
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
